import { type ComputedRef, computed } from 'vue';

import useAuth from '@/composables/useAuth';
import { TEMP_NEW_ONBOARDING_SMART } from '@/constants/feature_flags';
import { useFeatureFlagStore } from '@/stores/FeatureFlagStore';
import { isOrgInSmartOnboardingTestGroup } from '@/utils/abTestGate';

export default function useHasSmartOnboardingAccess(): ComputedRef<boolean> {
  const { hasFeatureFlag } = useFeatureFlagStore();
  const { currentOrg } = useAuth();

  return computed(() => {
    if (!hasFeatureFlag(TEMP_NEW_ONBOARDING_SMART)) return false;
    return isOrgInSmartOnboardingTestGroup(currentOrg.value.id);
  });
}
